export default __webpack_public_path__ + "static/media/Sentiment_01_Result_02.35847bcc.png";